export function Mitchell1Service (
  $q,
  $sce,
  $translate,
  $window,
  sessionObjAPI,
  workshopAPI
) {
  const Mitchell1 = function (customer, vehicle) {
    this.customer = customer || {};
    this.origin   = sessionObjAPI.base().origin;
    this.vehicle  = vehicle || {};
  };

  Mitchell1.prototype._getBuildYear = function () {
    const self = this;

    return self.vehicle.build_date  ?
      ( self.vehicle.build_date.indexOf('/') >= 0 ? self.vehicle.build_date.split('/')[1] : self.vehicle.build_date ) :
      '';
  };

  Mitchell1.prototype.addItems = function (invoice) {
    const self = this;

    return workshopAPI.post('/mitchell1/get_token_and_uri')
    .then((session = {}) => {
      const deferred = $q.defer();

      if (session.auth_token && !session.auth_token.access_token) {
        deferred.reject($translate.instant('GENERAL_SPACE.ERROR_MESSAGE.INVALID_CREDENTIALS', { name: 'Mitchell1' }));
      }

      if (typeof ShopIntegration !== 'undefined') {
        deferred.resolve(session);
      }

      self.scriptTag = $window.document.createElement('script');

      self.scriptTag.setAttribute('src', $sce.trustAsResourceUrl(session.intent_url.endpoints[0].uri));

      self.scriptTag.addEventListener('error', ( evt ) => deferred.reject(evt));
      self.scriptTag.addEventListener('load', () => deferred.resolve(session));

      $window.document.head.appendChild(self.scriptTag);

      return deferred.promise;
    })
    .then(session => self.integrateShop(invoice, session));
  };

  Mitchell1.prototype.cleanup = function () {
    if (this.scriptTag) {
      this.scriptTag.removeAllListeners('error');
      this.scriptTag.removeAllListeners('load');
    }
  };

  Mitchell1.prototype.getVehicle = function (session) {
    const self     = this;
    const deferred = $q.defer();

    const params = self.vehicle.vin ? {
      preferVinUiSelector: false,
      vehicleInformation : {
        vin: self.vehicle.vin
      }
    } : {
      vehicle: {
        engine  : self.vehicle.engine_code,
        make    : self.vehicle.make,
        model   : self.vehicle.model,
        subModel: self.vehicle.model_code,
        year    : self._getBuildYear()
      }
    };

    const vehicleIntegration = new ShopIntegration.Intent(
      'mitchell1.intent.action.pick',
      'vendor/vnd.m1.vehicle.pick.v2',
      params
    );

    vehicleIntegration.onFail = function (err = {}) {
      if (err.message) {
        deferred.reject(err.message);
      }
      else {
        deferred.reject(err);
      }
    };

    vehicleIntegration.onSuccess = function (response) {
      deferred.resolve({
        initialTab: 'Parts',
        vehicle   : response.vehicleInformation.qualifiers
      });
    };

    $window.IntegrationManager.start(vehicleIntegration, session.auth_token.access_token);

    return deferred.promise;
  };

  Mitchell1.prototype.integrateShop = function (invoice, session) {
    const self     = this;

    return self.getVehicle(session)
    .then(params => {
      const deferred = $q.defer();

      const shopIntegration = new ShopIntegration.Intent(
        'mitchell1.intent.action.pick',
        'vendor/vnd.m1.partslabor.pick.v2',
        params,
        {
          method: 'new',
          width : 900,
          height: 500
        }
      );

      shopIntegration.onFail = function (err = {}) {
        if (err.message) {
          deferred.reject(err.message);
        }
        else {
          deferred.reject(err);
        }
      };

      shopIntegration.onSuccess = function (response) {
        workshopAPI.post('/invoices/add_items_from_mitchell1', {
          invoice_id: invoice.id,
          response
        }, 'mitchell1')
        .then(result => {
          if (result && result !== 'false') {
            deferred.resolve(result);
          }
          else {
            deferred.reject(result);
          }
        })
        .catch(err => {
          deferred.reject(err);
        });
      };

      $window.IntegrationManager.start(shopIntegration, session.auth_token.access_token);

      return deferred.promise;
    });
  };

  return Mitchell1;
}
